import { Component } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import Navigation from "@/components/Navigation";
import Logo from "@/components/Logo";
import Input from "@/components/Input";
import LinkButton from "@/components/LinkButton";
import Button from "@/components/Button";
import ErrorText from "@/components/ErrorText";
import Log from "@/components/Log";

import { Observer } from "mobx-vue";
import UnBindUserStore from "@/store/UnBindUserStore";

@Observer
@Component
export default class UnBindUser extends tsx.Component<any> {
  name = "unbingUser";

  state = UnBindUserStore;

  // 渲染解绑页面
  renderUnBind() {
    return (
      <div class="card">
        <Navigation title="爱云兔账号解绑" />
        <Logo />
        <Input
          error={this.state.inputError.type === "account"}
          change={(e: any) =>
            this.state.inputOnChange(e.target.value, "account")
          }
          value={this.state.accountInfo.account}
          iconName="signIn"
          placeholder="请输入您的账号"
        />
        <Input
          error={this.state.inputError.type === "password"}
          change={(e: any) =>
            this.state.inputOnChange(e.target.value, "password")
          }
          value={this.state.accountInfo.password}
          iconName="passWord"
          type="password"
          placeholder="请输入您的密码"
        />
        <ErrorText>{this.state.inputError.text}</ErrorText>
        <Log number="A005" trackId={this.state.accountInfo.account}>
          <Button click={() => this.state.weChatServerUnBinding()}>
            解除绑定
          </Button>
        </Log>
      </div>
    );
  }

  // 渲染解绑成功
  renderUnBindSuccess() {
    return (
      <div class="card">
        <Navigation title="爱云兔账号绑定" />
        <div class="bindPage">
          <div class="bindBox">
            <div class="img">
              <img src={require("@/assets/img/success.png")} alt="绑定成功" />
            </div>
            <div class="word">解绑成功</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.isUnBindUser) {
      return this.renderUnBindSuccess();
    } else {
      return this.renderUnBind();
    }
  }
}
